import { useState, useEffect } from "react";
import axios from "axios";
const useFetch = (method, url, params) => {
  const [data, setData] = useState([["Loading Data..."]]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState(null);
  const [isSuccess, setIsSuccess] = useState(null);

  // CORS for Deployment
  // axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

  const fetchData = async (method, url, params) => {
    // url = `http://localhost:3000${url}`;
    url = `https://api.agcolk.com${url}`;
    const token = `Bearer ${localStorage.getItem("authToken")}`;
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // "Access-Control-Allow-Origin": "https://iqpaints.cf",
      },
    };
    const abortController = new AbortController();
    setIsLoading(true);
    setData([["Loading Data..."]]);
    await axios({
      method,
      url,
      signal: abortController.signal,
      // data,
      params,
      config,
    })
      .then((res) => {
        // console.log(res);
        setIsLoading(false);
        setData(res.data.data);
        setCount(res.data.count);
        setSummary(res.data.summary);
        setError(null);
        setIsSuccess(true);
        // return { error: false, isSuccess: true };
      })
      .catch((err) => {
        // console.log(err);
        if (err.message === "Request failed with status code 401")
          localStorage.removeItem("authToken");
        if (err.name !== "AbortError") {
          // auto catches network / connection error
          setIsLoading(false);
          setError(err.message);
          setIsSuccess(false);
          // setError((state) => {
          //   // console.log(state);
          //   return state;
          // });
        }
        if (err.name === "AbortError") return () => abortController.abort();
      });
  };

  const fetchOtherData = async (method, url, params) => {
    // url = `http://localhost:3000${url}`;
    url = `https://api.agcolk.com${url}`;
    let response;
    const token = `Bearer ${localStorage.getItem("authToken")}`;
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // "Access-Control-Allow-Origin": "https://iqpaints.cf",
      },
    };
    const abortController = new AbortController();
    setIsLoading(true);
    await axios({
      method,
      url,
      signal: abortController.signal,
      // data,
      params,
      config,
    })
      .then((res) => {
        // console.log(res);
        setIsLoading(false);
        setError(null);
        setIsSuccess(true);
        response = res;
      })
      .catch((err) => {
        // console.log(err);
        if (err.message === "Request failed with status code 401")
          localStorage.removeItem("authToken");
        if (err.name !== "AbortError") {
          // auto catches network / connection error
          setIsLoading(false);
          setError(err.message);
          setIsSuccess(false);
          // setError((state) => {
          //   // console.log(state);
          //   return state;
          // });
        }
        if (err.name === "AbortError") return () => abortController.abort();
      });
    return response;
  };

  const sendData = async (method, url, data, getUrl, params) => {
    // url = `http://localhost:3000${url}`;
    url = `https://api.agcolk.com${url}`;
    let error, isSuccess;
    const token = `Bearer ${localStorage.getItem("authToken")}`;
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // "Access-Control-Allow-Origin": "http://localhost:3006",
      },
    };
    const abortController = new AbortController();
    setIsLoading(true);
    setData([["Loading Data..."]]);
    await axios({
      method,
      url,
      signal: abortController.signal,
      data,
      config,
    })
      .then((res) => {
        // console.log(res);
        fetchData("get", getUrl, params);
        isSuccess = true;
        error = false;
        // setIsLoading(false);
        // setData(res.data.data);
        // setError(null);
      })
      .catch((err) => {
        // console.log(err, err.response);
        if (err.message === "Request failed with status code 401")
          localStorage.removeItem("authToken");
        if (err.name !== "AbortError") {
          // auto catches network / connection error
          fetchData("get", getUrl, params);
          setIsLoading(false);
          setError(err.message);
          setIsSuccess(false);
          isSuccess = false;
          error = err.response.data.message;
        }
        if (err.name === "AbortError") return () => abortController.abort();
      });
    return { error, isSuccess };
  };

  const deleteData = async (method, url, data, getUrl, params) => {
    // url = `http://localhost:3000${url}`;
    url = `https://api.agcolk.com${url}`;
    let error, isSuccess;
    const token = `Bearer ${localStorage.getItem("authToken")}`;
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // "Access-Control-Allow-Origin": "http://localhost:3006",
      },
    };
    const abortController = new AbortController();
    setIsLoading(true);
    setData([["Loading Data..."]]);
    await axios({
      method,
      url,
      signal: abortController.signal,
      config,
    })
      .then((res) => {
        // console.log(res);
        fetchData("get", getUrl, params);
        isSuccess = true;
        error = false;
        // setIsLoading(false);
        // setData(res.data.data);
        // setError(null);
      })
      .catch((err) => {
        // console.log(err);
        if (err.message === "Request failed with status code 401")
          localStorage.removeItem("authToken");
        if (err.name !== "AbortError") {
          // auto catches network / connection error
          fetchData("get", getUrl, params);
          setIsLoading(false);
          setError(err.message);
          setIsSuccess(false);
          isSuccess = false;
          error = err.message;
        }
        if (err.name === "AbortError") return () => abortController.abort();
      });
    return { error, isSuccess };
  };
  useEffect(() => {
    fetchData(method, url, params);
  }, [url, params]);

  return [
    { data, isLoading, count, error, summary, isSuccess },
    fetchData,
    fetchOtherData,
    sendData,
    deleteData,
  ];
};

export default useFetch;

const KEYS = {
  employees: "employees",
  employeeId: "employeeId",
};

export const getRolesCollection = () => [
  { id: "admin", title: "Admin" },
  { id: "moderator", title: "Moderator" },
];

export const getAccountsCollection = () => [
  { id: "IQPF", title: "IQPF" },
  { id: "IQC", title: "IQC" },
  { id: "KS", title: "KS" },
];

export const getExpenceTypesCollection = () => [
  { id: "Akzo Nobel Paints", title: "Akzo Nobel Paints" },
  { id: "Bonus", title: "Bonus" },
  { id: "Consultant Fee", title: "Consultant Fee" },
  { id: "EPF", title: "EPF" },
  { id: "ETF", title: "ETF" },
  { id: "Internal Transactions", title: "Internal Transactions" },
  { id: "Layley Paints", title: "Layley Paints" },
  { id: "Loans", title: "Loans" },
  { id: "Mahanama Paints", title: "Mahanama Paints" },
  { id: "Other Purchasing", title: "Other Purchasing" },
  { id: "Rent Payment", title: "Rent Payment" },
  { id: "Sub Contractor Advance", title: "Sub Contractor Advance" },
  {
    id: "Sub Contractor Balance Payment",
    title: "Sub Contractor Balance Payment",
  },
  { id: "Other", title: "Other" },
];

export const getDailyExpenseTypesCollection = () => [
  { id: "Advance", title: "Advance" },
  { id: "Petty Cash to Sonali", title: "Petty Cash to Sonali" },
  { id: "Petty Cash to Sugath", title: "Petty Cash to Sugath" },
  { id: "Petty Cash to Sanjeewa", title: "Petty Cash to Sanjeewa" },
  { id: "Mr Sampath Bills", title: "Mr Sampath Bills" },
  { id: "Mobile Expenses", title: "Mobile Expenses" },
  { id: "Transport", title: "Transport" },
  { id: "Traveling", title: "Traveling" },
  { id: "Fuel", title: "Fuel" },
  { id: "Purchasing", title: "Purchasing" },
  { id: "Refreshment", title: "Refreshment" },
  { id: "Welfare", title: "Welfare" },
  { id: "Consultant Fee", title: "Consultant Fee" },
  { id: "Allowance", title: "Allowance" },
  { id: "Other", title: "Other" },
];

export const getDistrictsCollection = () => [
  {
    id: "Colombo",
    title: "Colombo",
  },

  {
    id: "Kandy",
    title: "Kandy",
  },

  {
    id: "Kurunegala",
    title: "Kurunegala",
  },

  {
    id: "Ratnapura",
    title: "Ratnapura",
  },

  {
    id: "Galle",
    title: "Galle",
  },

  {
    id: "Ampara",
    title: "Ampara",
  },

  {
    id: "Anuradhapura",
    title: "Anuradhapura",
  },

  {
    id: "Badulla",
    title: "Badulla",
  },

  {
    id: "Batticaloa",
    title: "Batticaloa",
  },

  {
    id: "Gampaha",
    title: "Gampaha",
  },

  {
    id: "Hambantota",
    title: "Hambantota",
  },

  {
    id: "Jaffna",
    title: "Jaffna",
  },

  {
    id: "Kalutara",
    title: "Kalutara",
  },

  {
    id: "Kegalle",
    title: "Kegalle",
  },

  {
    id: "Kilinochchi",
    title: "Kilinochchi",
  },

  {
    id: "Mannar",
    title: "Mannar",
  },

  {
    id: "Matale",
    title: "Matale",
  },

  {
    id: "Matara",
    title: "Matara",
  },

  {
    id: "Monaragala",
    title: "Monaragala",
  },

  {
    id: "Mullativu",
    title: "Mullativu",
  },

  {
    id: "Nuwara Eliya",
    title: "Nuwara Eliya",
  },

  {
    id: "Polonnaruwa",
    title: "Polonnaruwa",
  },

  {
    id: "Puttalam",
    title: "Puttalam",
  },

  {
    id: "Trincomalee",
    title: "Trincomalee",
  },

  {
    id: "Vavuniya",
    title: "Vavuniya",
  },
];

export function insertEmployee(data) {
  let employees = getAllEmployees();
  data["id"] = generateEmployeeId();
  employees.push(data);
  localStorage.setItem(KEYS.employees, JSON.stringify(employees));
}

export function updateEmployee(data) {
  let employees = getAllEmployees();
  let recordIndex = employees.findIndex((x) => x.id == data.id);
  employees[recordIndex] = { ...data };
  localStorage.setItem(KEYS.employees, JSON.stringify(employees));
}

export function deleteEmployee(id) {
  let employees = getAllEmployees();
  employees = employees.filter((x) => x.id != id);
  localStorage.setItem(KEYS.employees, JSON.stringify(employees));
}

export function generateEmployeeId() {
  if (localStorage.getItem(KEYS.employeeId) == null)
    localStorage.setItem(KEYS.employeeId, "0");
  var id = parseInt(localStorage.getItem(KEYS.employeeId));
  localStorage.setItem(KEYS.employeeId, (++id).toString());
  return id;
}

export function getAllEmployees() {
  if (localStorage.getItem(KEYS.employees) == null)
    localStorage.setItem(KEYS.employees, JSON.stringify([]));
  let employees = JSON.parse(localStorage.getItem(KEYS.employees));
  //map departmentID to department title
  let roles = getRolesCollection();
  return employees.map((x) => ({
    ...x,
    role: roles[x.role - 1].title,
  }));
}
